var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab',{class:_vm.classes,style:(_vm.styles),attrs:{"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.icon)?_c('base-icon',{staticClass:"ml-2",attrs:{"icon":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }